/** Доля владения: в UI «1/5», в API — доля от 1 (0…1). */

const gcd = (a: number, b: number): number => {
  let x = Math.abs(Math.trunc(a));
  let y = Math.abs(Math.trunc(b));
  while (y) {
    const t = y;
    y = x % y;
    x = t;
  }
  return x || 1;
};

/** Доля 0…1 → упрощённая запись («1/5», «1»). */
export function fractionToLabel(
  share: number,
  maxDenominator = 48
): string {
  const x = Number(share);
  if (!Number.isFinite(x) || x < 0) return '—';
  if (x === 0) return '0';
  if (Math.abs(x - 1) < 0.0005) return '1';

  let bestN = 1;
  let bestD = 1;
  let bestErr = Infinity;
  for (let d = 1; d <= maxDenominator; d += 1) {
    const n = Math.round(x * d);
    if (n < 0) continue;
    const err = Math.abs(x - n / d);
    if (err < bestErr - 1e-12 || (Math.abs(err - bestErr) < 1e-12 && d < bestD)) {
      bestErr = err;
      bestN = n;
      bestD = d;
    }
  }
  const g = gcd(bestN, bestD);
  const n = bestN / g;
  const d = bestD / g;
  if (d === 1) return String(n);
  return `${n}/${d}`;
}

export function formatOwnershipShare(
  share: number | null | undefined
): string {
  if (share == null || !Number.isFinite(Number(share))) return '—';
  return fractionToLabel(Number(share));
}

/** В истории и на карточке борта не показываем участников с нулевой долей. */
export function isPositiveOwnershipShare(
  share: number | null | undefined
): boolean {
  return share != null && Number.isFinite(Number(share)) && Number(share) > 0;
}

/** «1/5» → 0.2; пустая строка → null; иначе invalid. */
export function parseOwnershipShareInput(
  raw: string
): number | null | 'invalid' {
  const text = raw.trim().replace(',', '.').replace(/%/g, '');
  if (text === '') return null;

  const frac = text.match(/^(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
  if (frac) {
    const n = Number(frac[1]);
    const d = Number(frac[2]);
    if (!Number.isFinite(n) || !Number.isFinite(d) || d <= 0 || n < 0) {
      return 'invalid';
    }
    const share = Math.round((n / d) * 1e6) / 1e6;
    if (share > 1) return 'invalid';
    return share;
  }

  // Число без дроби — уже доля 0…1 (или устаревший % > 1 → делим на 100)
  const asNum = Number(text);
  if (!Number.isFinite(asNum) || asNum < 0) return 'invalid';
  if (asNum <= 1) return Math.round(asNum * 1e6) / 1e6;
  if (asNum <= 100) return Math.round((asNum / 100) * 1e6) / 1e6;
  return 'invalid';
}

export function formatOwnershipShareSum(shareSum: number): string {
  if (!Number.isFinite(shareSum)) return '—';
  return fractionToLabel(shareSum);
}

/** Сумма долей собственников должна быть 1 (±0.0002). */
export function isOwnershipShareSumComplete(shareSum: number): boolean {
  return Number.isFinite(shareSum) && Math.abs(shareSum - 1) <= 0.0002;
}
